<template>
  <v-col cols="12" class="test_blue">
    <v-radio-group
      v-model="selected"
      mandatory
      class="input-group-radio-stretch"
    >
      <template v-slot:label>
        <span class="modal-title-details" v-text="title" />
      </template>

      <template v-for="(item, index) in datas">
        <v-radio :key="index" :value="item.pivotId">
          <template v-slot:label>
            <!-- Wrap label content in a flex row -->
            <v-row no-gutters align="start" class="radio-label-row">
              <v-col
                cols="8"
                class="modal-name-details"
                style="margin-top: 6px"
              >
                {{ item.name }}
              </v-col>
              <v-col
                cols="4"
                style="margin-top: 6px"
                class="modal-price-details text-right"
                :class="show(item.pivotId) ? 'active' : 'inactive'"
              >
                {{ $appFormatters.formatMoney(item.price) }}
              </v-col>
            </v-row>
          </template>
        </v-radio>
      </template>
    </v-radio-group>
  </v-col>
</template>

<script>
export default {
  name: "AddonSimpleSubcomponent",
  props: {
    title: {
      type: String,
      required: true,
    },
    datas: {
      type: Array,
      default: null,
    },
  },
  data: () => ({
    selected: null,
    detailsSelected: [],
  }),
  watch: {
    selected: function (id) {
      this.detailsSelected = [];
      this.creatArray(id);
    },

    detailsSelected: function () {
      this.$emit("input", this.detailsSelected);
    },
  },
  methods: {
    creatArray: function (id) {
      const self = this;
      let item = _.find(self.datas, {
        pivotId: id,
      });
      self.detailsSelected = {
        productSubAddonPivotId: id,
        price: item.price,
        subAddonQty: 1,
        subtotal: item.price,
      };
    },
    show: function (id) {
      const self = this;
      return self.selected === id;
    },
  },
};
</script>
